import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getServiceShopForRegion = createAsyncThunk('/GetServiceShopForRegion', async (parentSourceServiceShopId) => {
  const response = await axios.get(`/GetServiceShopForRegion/${parentSourceServiceShopId}`);
  return response.data;
});

export const getTaskData = createAsyncThunk('/getTaskData',
  async (ids) => {
    const response = await axios.get(`/GetTasksDataJobControl/${ids[0]}/${ids[1]}/${ids[2]}/${ids[3]}/${ids[4]}/${ids[5]}/${ids[6]}`);
    return response.data;
  });

export const GetJobControlCases = createAsyncThunk('/GetJobControlCases',
  async (ids) => {
    const response = await axios.get(`/GetJobControlCases/${ids[0]}/${ids[1]}/${ids[2]}/${ids[3]}/${ids[4]}/${ids[5]}/${ids[6]}/${ids[7]}/${ids[8]}`);
    return response.data;
  });

export const getWorkBenchData = createAsyncThunk('/GetWorkBenchData',
  async (ids) => {
    const response = await axios.get(`/GetWorkBenchData/${ids[0]}/${ids[1]}/${ids[2]}/${ids[3]}/${ids[4]}/${ids[5]}`);
    return response.data;
  });

export const getTasksDataByIssue = createAsyncThunk('/GetTasksDataByIssueForCustomerFeedBack',
  async (ids) => {
    const response = await axios.get(`/GetTasksDataByIssueForCustomerFeedBack/${ids[0]}/${ids[1]}/${ids[2]}/${ids[3]}`);
    return response.data;
  });

export const getConsumerWorkOrderPaymentControlByStatus = createAsyncThunk('/getConsumerWorkOrderPaymentControlByStatus',
  async (ids) => {
    const response = await axios.get(`/GetConsumerWorkOrderPaymentControlByStatus/${ids[0]}/${ids[1]}`);
    return response.data;
  });

export const getJobControlCases = createAsyncThunk('/getJobControlCases',
  async (ids) => {
    const response = await axios.get(`/getJobControlCases/${ids[0]}/${ids[1]}`);
    return response.data;
  });

export const getSiriusCloseStatus = createAsyncThunk('/getSiriusCloseStatus',
  async () => {
    const response = await axios.get('/GetSiriusCloseStatus');
    return response.data;
  });

export const getRejectReason = createAsyncThunk('/getRejectReason',
  async () => {
    const response = await axios.get('/GetRejectReasonJobControl');
    return response.data;
  });

export const setTaskStatus = createAsyncThunk('/SetTaskStatus',
  async (data) => {
    const response = await axios.post('/SetTaskStatus', data);
      return response.data; 
  });

export const setWorkbenchStatus = createAsyncThunk('/SetWorkbenchStatus',
  async (data) => {
    const response = await axios.post('/SetWorkbenchStatus', data);
    return response.data;
  });

export const setTaskStatusByIssue = createAsyncThunk('/SetTaskStatusByIssue',
  async (data) => {
    const response = await axios.post('/SetTaskStatusByIssue', data);
    return response.data;
  });

export const getWorkOrderStatusLogic = createAsyncThunk('/GetWorkOrderStatusLogic', async (Param) => {
  const response = await axios.get(`/GetWorkOrderStatusLogic/${Param}`);
  return response.data;
});

export const getWorkOrderJobControlLogic = createAsyncThunk('/GetWorkOrderJobControlLogic', async (Param) => {
  const response = await axios.get(`/GetWorkOrderJobControlLogic/${Param}`);
  return response.data;
});

export const getCaseStatus = createAsyncThunk('/GetCaseStatus', async () => {
  const response = await axios.get(`/GetCaseStatus`);
  return response.data;
});

export const getWorkCaseFeedbacks = createAsyncThunk('/GetWorkCaseFeedbacks', async (WorkCaseId) => {
  const response = await axios.get(`/GetWorkCaseFeedbacks/${WorkCaseId}`);
  return response.data;
});

export const getCaseStatusRule = createAsyncThunk('/getCaseStatusRule', async (StatusId) => {
  const response = await axios.get(`/GetCaseStatusRule/${StatusId}`);
  return response.data;
});

export const getJobControlStatus = createAsyncThunk('/getJobControlStatus', async () => {
  const response = await axios.get(`/GetJobControlStatus`);
  return response.data;
});

// YENİ: Region by Employee - Scheduling'deki gibi
export const getRegionByEmployee = createAsyncThunk('/getRegionByEmployee', async (employeeId) => {
  const response = await axios.get(`/GetRegionByEmployee/${employeeId}`);
  return response.data;
});

export const setRepairDate = createAsyncThunk('/SetRepairDate',async (data) => {
    const response = await axios.post('/SetRepairDate', data);
    return response.data;
  });

const jobControlSlice = createSlice({
  name: 'jobControl',
  initialState: {
    loading: false,
    error: '',
    ServiceShopControl: [],
    WorkOrderInformation: [],
    JobOrderStatus: [],
    RejectReason: [],
    JobOrderLogicStatus: [],
    JobControlLogicStatus: [],
    CaseStatusRuleList: [],
    JobStatus: [],
    serviceShopSelected: null,
    statusSelected: null,
    RegionList: [] // YENİ: Region listesi için
  },
  reducers: {
    setServiceShopSelected(state, action) {
      state.serviceShopSelected = action.payload;
    },
    setStatusSelected(state, action) {
      state.statusSelected = action.payload;
    },
  },
  extraReducers: {
    [getServiceShopForRegion.pending]: (state) => {
      state.loading = true;
    },
    [getServiceShopForRegion.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getServiceShopForRegion.fulfilled]: (state, action) => {
      state.ServiceShopControl = action.payload;
      state.loading = false;
    },
    [getWorkOrderStatusLogic.pending]: (state) => {
      state.loading = true;
    },
    [getWorkOrderStatusLogic.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getWorkOrderStatusLogic.fulfilled]: (state, action) => {
      state.JobOrderLogicStatus = action.payload;
      state.loading = false;
    },
    [getWorkOrderJobControlLogic.pending]: (state) => {
      state.loading = true;
    },
    [getWorkOrderJobControlLogic.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getWorkOrderJobControlLogic.fulfilled]: (state, action) => {
      state.JobControlLogicStatus = action.payload;
      state.loading = false;
    },
    [getTaskData.pending]: (state) => {
      state.loading = true;
    },
    [getTaskData.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getTaskData.fulfilled]: (state, action) => {
      state.WorkOrderInformation = action.payload;
      state.loading = false;
    },
    [getConsumerWorkOrderPaymentControlByStatus.pending]: (state) => {
      state.loading = true;
    },
    [getConsumerWorkOrderPaymentControlByStatus.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getConsumerWorkOrderPaymentControlByStatus.fulfilled]: (state, action) => {
      state.WorkOrderInformation = action.payload;
      state.loading = false;
    },
    [getWorkBenchData.pending]: (state) => {
      state.loading = true;
    },
    [getWorkBenchData.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getWorkBenchData.fulfilled]: (state, action) => {
      state.WorkOrderInformation = action.payload;
      state.loading = false;
    },
    [getTasksDataByIssue.pending]: (state) => {
      state.loading = true;
    },
    [getTasksDataByIssue.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getTasksDataByIssue.fulfilled]: (state, action) => {
      state.WorkOrderInformation = action.payload;
      state.loading = false;
    },
    [getSiriusCloseStatus.pending]: (state) => {
      state.loading = true;
    },
    [getSiriusCloseStatus.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getSiriusCloseStatus.fulfilled]: (state, action) => {
      state.JobOrderStatus = action.payload;
      state.loading = false;
    },
    [getRejectReason.pending]: (state) => {
      state.loading = true;
    },
    [getRejectReason.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getRejectReason.fulfilled]: (state, action) => {
      state.RejectReason = action.payload;
      state.loading = false;
    },
    [setTaskStatus.pending]: (state) => {
      state.loading = true;
    },
    [setTaskStatus.rejected]: (state, action) => {

      state.error = action.error;
      state.loading = false;
    },
    [setTaskStatus.fulfilled]: (state, action) => {
      state.response = action.payload;
      state.loading = false;
    },
    [setWorkbenchStatus.pending]: (state) => {
      state.loading = true;
    },
    [setWorkbenchStatus.rejected]: (state, action) => {
      state.error = action.error;
      state.loading = false;
    },
    [setWorkbenchStatus.fulfilled]: (state, action) => {
      state.response = action.payload;
      state.loading = false;
    },
    [setTaskStatusByIssue.pending]: (state) => {
      state.loading = true;
    },
    [setTaskStatusByIssue.rejected]: (state, action) => {
      state.error = action.error;
      state.loading = false;
    },
    [setTaskStatusByIssue.fulfilled]: (state, action) => {
      state.response = action.payload;
      state.loading = false;
    },
    [getCaseStatus.pending]: (state) => {
      state.loading = true;
    },
    [getCaseStatus.rejected]: (state, action) => {
      state.error = action.error;
      state.loading = false;
    },
    [getCaseStatus.fulfilled]: (state, action) => {
      state.CaseStatusList = action.payload;
      state.loading = false;
    },
    [getCaseStatusRule.pending]: (state) => {
      state.loading = true;
    },
    [getCaseStatusRule.rejected]: (state, action) => {
      state.error = action.error;
      state.loading = false;
    },
    [getCaseStatusRule.fulfilled]: (state, action) => {
      state.CaseStatusRuleList = action.payload;
      state.loading = false;
    },
    [getJobControlStatus.pending]: (state) => {
      state.loading = true;
    },
    [getJobControlStatus.rejected]: (state, action) => {
      state.error = action.error;
      state.loading = false;
    },
    [getJobControlStatus.fulfilled]: (state, action) => {
      state.JobStatus = action.payload;
      state.loading = false;
    },
    // YENİ: Region by Employee reducers
    [getRegionByEmployee.pending]: (state) => {
      state.loading = true;
      state.error = '';
    },
    [getRegionByEmployee.rejected]: (state, action) => {
      state.error = action.error.message;
      state.loading = false;
    },
    [getRegionByEmployee.fulfilled]: (state, action) => {
      state.RegionList = action.payload;
      state.loading = false;
      state.error = '';
    }
  }
});

export const { setServiceShopSelected } = jobControlSlice.actions;
export const { setStatusSelected } = jobControlSlice.actions;
export const jobControlActions = jobControlSlice.actions;
export default jobControlSlice;